import styled, { keyframes, css } from "styled-components";

const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const pulse = keyframes`
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
`;

export const Container = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: var(--background);
`;

export const VerificationCard = styled.div`
  background: var(--surface);
  padding: 60px 40px;
  border-radius: 25px;
  border: 2px solid var(--accent-light);
  box-shadow: var(--shadow-soft);
  text-align: center;
  max-width: 500px;
  width: 100%;
  animation: ${fadeInUp} 0.8s ease-out;

  @media (max-width: 768px) {
    padding: 40px 30px;
    margin: 20px;
  }
`;

export const IconWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  margin-bottom: 30px;
  font-size: 36px;

  ${(props) => {
    switch (props.status) {
      case "success":
        return css`
          background: var(--success);
          color: var(--surface);
          animation: ${pulse} 1s ease-in-out;
        `;
      case "error":
        return css`
          background: var(--error);
          color: var(--surface);
        `;
      case "pending":
        return css`
          background: var(--accent-light);
          color: var(--accent);
          
          .spin {
            animation: ${spin} 1s linear infinite;
          }
        `;
      case "info":
      default:
        return css`
          background: var(--accent-light);
          color: var(--accent);
        `;
    }
  }}
`;

export const Title = styled.h1`
  font-size: 28px;
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: 20px;
  text-transform: uppercase;
  letter-spacing: 1px;

  @media (max-width: 768px) {
    font-size: 24px;
  }
`;

export const Message = styled.p`
  font-size: 16px;
  color: var(--text-secondary);
  line-height: 1.6;
  margin-bottom: 40px;
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
`;

export const ActionButton = styled.button`
  background: var(--gradient-primary);
  color: var(--surface);
  border: none;
  padding: 15px 30px;
  border-radius: 25px;
  font-size: 16px;
  font-weight: 600;
  font-family: inherit;
  text-transform: uppercase;
  letter-spacing: 1px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: var(--shadow-soft);

  &:hover {
    transform: translateY(-2px);
    box-shadow: var(--shadow-medium);
    background: var(--accent-dark);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
  }
`;

export const ResendSection = styled.div`
  margin: 30px 0;
  padding: 20px;
  background: var(--background);
  border-radius: 15px;
  border: 2px solid var(--accent-light);
`;

export const ResendText = styled.p`
  font-size: 14px;
  color: var(--text-secondary);
  margin-bottom: 15px;
`;

export const ResendButton = styled.button`
  background: transparent;
  color: var(--accent);
  border: 2px solid var(--accent-light);
  padding: 12px 24px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
  font-family: inherit;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 auto;

  &:hover:not(:disabled) {
    border-color: var(--accent);
    background: var(--accent);
    color: var(--surface);
    transform: translateY(-1px);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
  }
`;
